import { Bill } from '../../types/bills'
import { BillingActionTypes, SET_BILLS, SET_BILLS_LOADING, SET_BILLS_ERROR, SET_SELECTED_BILL } from './types'

export interface BillingState {
    bills: Bill[] | null
    loading: boolean
    error: string | null
    selectedBill: Bill | null
}

const initialState: BillingState = {
    bills: null,
    loading: false,
    error: null,
    selectedBill: null,
}

export const billingReducer = (
    state = initialState,
    action: BillingActionTypes,
): BillingState => {
    switch (action.type) {
        case SET_BILLS:
            return {
                ...state,
                bills: action.bills,
                loading: false,
                error: null,
            }
        case SET_BILLS_LOADING:
            return {
                ...state,
                loading: action.loading,
            }
        case SET_BILLS_ERROR:
            return {
                ...state,
                error: action.error,
                loading: false,
            }
        case SET_SELECTED_BILL:
            return {
                ...state,
                selectedBill: action.bill,
            }
        default:
            return state
    }
} 